var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-button",
        {
          directives: [
            {
              name: "permit",
              rawName: "v-permit:remove",
              value:
                "btn:finance:reportDashboard:report:dailyCollectionReceivableReport:refresh",
              expression:
                "'btn:finance:reportDashboard:report:dailyCollectionReceivableReport:refresh'",
              arg: "remove",
            },
          ],
          attrs: {
            type: "primary",
            size: "small",
            icon: "el-icon-refresh-left",
          },
          on: { click: _vm.onOpen },
        },
        [_vm._v(_vm._s(_vm.$t("basicData.刷新数据")))]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("basicData.刷新数据"),
            visible: _vm.isDialog,
            width: "500px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.isDialog = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-width": "120px",
              },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("basicData.BusinessTime"),
                    prop: "operatorTime",
                  },
                },
                [
                  _c("el-date-picker", {
                    attrs: {
                      "picker-options": _vm.pickerOptions,
                      type: "date",
                      "value-format": "yyyy-MM-dd",
                      placeholder: _vm.$t("operationCenter.PleaseSelect"),
                    },
                    model: {
                      value: _vm.form.operatorTime,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "operatorTime", $$v)
                      },
                      expression: "form.operatorTime",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.isDialog = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("GlobalSetObj.cancel")))]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.submitForm } },
                [_vm._v(_vm._s(_vm.$t("GlobalSetObj.determine")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }